import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Title text="Media" mdxType="Title" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.kyobobook.co.kr/product/detailViewKor.laf?barcode=9791188621521"
        }}>{`Book: Terraform 설치에서 운영까지`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=6v_6OTlVmX0"
        }}>{`Video: AWS Seoul Summit - Transform to mobile game`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://youtu.be/eViUVtL-_hw"
        }}>{`Video: Tacademy - AWS Essential`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      